import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder" }, "Recepción"),
  /*#__PURE__*/_createElementVNode("p", { class: "lead fw-normal text-muted mb-0" }, "Envíar Alertas")
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "dest",
  class: "form-label"
}, "Destino: *", -1)
const _hoisted_8 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "dest2",
  class: "form-label"
}, "Seleccione las Habitaciones: *", -1)
const _hoisted_10 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "dest3",
  class: "form-label"
}, "Seleccione Una Habitación: *", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "pri",
  class: "form-label"
}, "Categoría: *", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "mjs",
  class: "form-label"
}, "Mensaje: *", -1)
const _hoisted_19 = { class: "col-5" }
const _hoisted_20 = { class: "mensajes-table" }
const _hoisted_21 = { class: "mensajes-list" }

export function render(_ctx, _cache) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Button = _resolveComponent("Button")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Panel = _resolveComponent("Panel")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers((...args) => (_ctx.enviarMensaje && _ctx.enviarMensaje(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Dropdown, {
                id: "dest",
                class: "vue-input",
                options: _ctx.destino,
                modelValue: _ctx.selectDestino,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectDestino) = $event)),
                optionLabel: "valor",
                name: "dest",
                optionValue: "id",
                placeholder: "Seleccionar..."
              }, null, 8, ["options", "modelValue"])
            ]),
            (_ctx.selectDestino == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_MultiSelect, {
                    id: "dest2",
                    class: "vue-input",
                    options: _ctx.habitaciones,
                    modelValue: _ctx.selectDestino2,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.selectDestino2) = $event)),
                    optionLabel: "habitacion",
                    name: "select2",
                    display: "chip",
                    optionValue: "idHabitacion",
                    placeholder: "Seleccionar..."
                  }, null, 8, ["options", "modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectDestino == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_Dropdown, {
                    id: "dest3",
                    class: "vue-input",
                    options: _ctx.habitaciones,
                    modelValue: _ctx.selectDestino3,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.selectDestino3) = $event)),
                    optionLabel: "habitacion",
                    name: "select2",
                    optionValue: "idHabitacion",
                    placeholder: "Seleccionar..."
                  }, null, 8, ["options", "modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_Dropdown, {
                class: "vue-input",
                options: _ctx.categorias,
                modelValue: _ctx.mensaje.prioridad,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.mensaje.prioridad) = $event)),
                optionLabel: "valor",
                name: "select1",
                optionValue: "id",
                placeholder: "Seleccionar...",
                id: "pri"
              }, null, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_Button, {
                type: "submit",
                class: "btn-brand-secnd",
                severity: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Enviar "),
                  _hoisted_15
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_Textarea, {
                class: "vue-text-area",
                id: "msj",
                modelValue: _ctx.mensaje.data,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.mensaje.data) = $event)),
                autoResize: "",
                title: "Mensaje para el Paciente"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_Panel, { header: "Mensajes Predefinidos" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_DataTable, {
              value: _ctx.defaultMessages,
              stripedRows: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, { header: "Acciones" }, {
                  body: _withCtx((prop) => [
                    _createVNode(_component_Button, {
                      class: "me-2",
                      severity: "success",
                      icon: "fa fa-angles-left",
                      onClick: $event => (_ctx.addMsgToMain(prop.data))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "prioridad",
                  header: "Categoría"
                }, {
                  body: _withCtx((prop) => [
                    _createTextVNode(_toDisplayString(_ctx.formatCategoria(prop.data.prioridad)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "mensaje",
                  header: "Mensaje"
                }, {
                  body: _withCtx((prop) => [
                    _createElementVNode("p", _hoisted_21, _toDisplayString(prop.data.mensaje), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}